import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';

export const useUpdateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likedFolderService.put,
    throwOnError: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.getInfiniteLikeFolders,
      });
    },
  });
};
